export const themeGlobal = {
  direction:'rtl',
  colors: {
    primary: '#3353B2',
    secondary: '#E2E8F0',
    success: '#9CCC2C',
    warning: '#FBCB1A',
    danger: '#D73F3F',
    dark: '#434C5B',
  },
  borderRadius: {
    sm: '.375rem',
    lg: '9999px',
  },
  fontSizes: {
    small: '1em',
    medium: '2em',
    large: '3em',
  },
}
